import { Heading } from "@chakra-ui/react";
import { ReactNode } from "react";

function PageSectionTitle({ children }: { children: ReactNode }) {
	return (
		<Heading as="h2" fontWeight={600} fontSize="18px" lineHeight="27px">
			{children}
		</Heading>
	);
}

export default PageSectionTitle;
